<template>
<div class="docSign_list">
    <div class="docSign_content" v-if="mediatorState">
        <div class="tit">送达文书</div>
        <template v-if="workerDocumentList.length">
            <template v-for="(item,index) in workerDocumentList">
                <el-card :key="index" class="box-card" shadow="hover">
                    <div slot="header" class="doc_list_head">
                        <span>{{item.docName}}</span>
                    </div>
                    <div class="doc_item" v-for="(doc, index) in item.list" :key="index">
                        <el-row :gutter="24" class="flex-center">
                            <el-col :span="8">
                                <span class="doc_name"><i class="el-icon-document"></i> {{doc.fileName}}</span>
                                <template  v-if="doc.sign != 'GZZC_PUBLIC_SERVICE_RECEIPT'">
                                    <el-tag v-if="doc.docSendLogStatus == '1'" type="success" style="margin-left: 20px">已发</el-tag>
                                    <el-tag v-else type="warning"  style="margin-left: 20px">未发</el-tag>
                                </template>
                            </el-col>
                            <el-col class="flex-center" :span="10" v-if="doc.sign == 'GZZC_PUBLIC_SERVICE_RECEIPT'">
                                <span style="width: 60px; flex-shrink: 0">签收情况：</span>
                                <div class="flex-center" style="overflow-x: auto">
                                    <template v-for="(item,index) in doc.confirmList">
                                        <el-tag v-if="item.confirmStatus" :key="index" type="success" class="el-icon-success" style="height: 44px; line-height: 18px; padding-top: 4px;">
                                            <span>{{item.userName}}</span><br><span>{{item.sendTime}}</span>
                                        </el-tag>
                                        <el-tag v-else :key="index" type="warning" class="el-icon-question">{{item.userName}}</el-tag>
                                    </template>
                                </div>
                            </el-col>
                            <el-col class="flex-center" :span="10" v-else>
                                <span style="width: 60px; flex-shrink: 0">送达情况：</span>
                                <div class="flex-center" style="overflow-x: auto">
                                    <template v-for="(item,index) in doc.deliveryList">
                                        <el-tag v-if="item.deliveryStatus == '1'" :key="index" type="success" class="el-icon-success">
                                            <span>{{item.userName}}</span>
                                        </el-tag>
                                        <el-tag v-else :key="index" type="warning" class="el-icon-question">{{item.userName}}</el-tag>
                                    </template>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <el-button type="text" v-if="!isClosed && !isManage" @click="deletefile(doc)">删除</el-button>
                                <el-button type="text" @click="downfile(doc,false)">下载</el-button>
                                <el-button type="text" @click="preview(doc,false)">预览</el-button>
                                <el-button type="text" v-if="doc.sign != 'GZZC_PUBLIC_SERVICE_RECEIPT' && !isClosed && !isManage" @click="sendAgain(doc)">发送至邮箱或手机</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </template>
        </template>
        <template v-else>
            <el-card class="box-card" shadow="hover">
                <div class="text item">暂无文书</div>
            </el-card>
        </template>
    </div>
    <template v-if="mediatorState">
        <div class="docSign_foot">
            <el-button :disabled="isClosed || isManage" type="primary" style="margin-top: 40px" @click="handleSendBook">发送文书</el-button>
            <div class="docSign_foot_block">预留签字：
                <template v-for="(item,index) in confirmList">
                    <div :key="index" style="display: flex">
                        <el-tag v-if="item.status == '0'" type="success left" class="el-icon-success">{{item.userName}}</el-tag>
                        <el-tag v-else type="warning" class="el-icon-question left">{{item.userName}}</el-tag>
                        <img v-if="item.signatureFileUrl" :src="item.signatureFileUrl" mode="aspectFit" style="width: 80px; height: 32px; margin-left: 10px" />
                    </div>
                </template>
                <a class="resign" v-if="!isClosed && !isManage" @click="showReSignDialog">通知签署(重签)预留签名</a>
            </div>
            <div class="email_block">
                <div class="email_item" style="margin-right: 10px">预留邮箱：</div>
                <template v-for="(item,index) in emailList">
                    <div :key="index" class="email_item">
                        <div style="margin-right: 15px">{{item.userName}}</div>
                        <el-input :disabled="!item.editStatus" v-model="item.email" style="width: 280px" placeholder="未登记"></el-input>
                        <el-button type="text" v-if="item.editStatus" @click="editEmail(item, 1)">取消</el-button>
                        <el-button type="text" v-if="!isClosed && !isManage" @click="editEmail(item, 0)">{{item.editStatus? '完成':'修改'}}</el-button>
                    </div>
                </template>
            </div>
        </div>
    </template>
    <sendDialog ref="senddialog" :wsLink="wsLink" :currentRoomId="currentRoomId" @compontCallback="documentsUpdate" @loadPage="loadPage"></sendDialog>
    <el-dialog class="booksign_dialog" title="通知签署(重签)预留签名" :visible.sync="resignDialog" width="600px" center :modal-append-to-body="false" :show-close="false">
        <el-form label-width="80px">
            <el-form-item label="发送人员">
                <el-checkbox-group v-model="reSignArr">
                    <el-checkbox v-for="(item, index) in confirmList" :key="index" :label="item.userName" name="type"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeReSignDialog">取 消</el-button>
            <el-button type="primary" @click="reSignAgain">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog class="booksign_dialog" title="选择接收人员" :visible.sync="againDialog" width="600px" center :modal-append-to-body="false" :show-close="false">
        <el-form label-width="80px">
            <el-form-item label="" label-width="50px">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChanged">全选</el-checkbox>
                <el-checkbox-group v-model="againArr" @change="handleAgainArrChanged">
                    <el-checkbox v-for="(item, index) in emailList" :key="index" :label="item.userId" name="type">{{item.userName}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeAgainDialog">取 消</el-button>
            <el-button type="primary" :loading="BtnLoading" @click="sendDocAgain">发 送</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import AlertEmit from './alertEmit'
import {getUserSingnatureAndEmail, setUserEmail, manualSendDeliveryDoc} from "../../../api/casespace";
import { userSignAgain } from "@/api/casespace_doclist.js";
import { onlineDocList, delDocAndAttach} from "../../../api/casespace";
import sendDialog from "./sendDialog.vue"
import {getStore,dateformat} from '@/utils/utils.js'
import filedownload from '@/api/filedown.js'
import config from '@/config/config'
import {
    userButton
} from "@/common/js/buttonMixin.js"
import deepClone from 'clone-deep'
import {isManageRole} from "../../../utils/utils";

export default {
    components: {
        sendDialog
    },
    mixins: [userButton],
    data() {
        return {
            workerDocumentList: [],
            documentList: [],
            documentListUnsigned: [],
            documentFileList: [],
            curRoomId: null,
            dialogVisibleSign: false,
            dialogVisibleSignCommon: false,
            noSignDialog: false,
            checkedDocId: '',
            weixincode: '',
            BtnLoading: false,
            curUserInfo: {},
            isClosed: localStorage.getItem('CloseState') == 'true' ? true : false,
            BtnSignLoading: [],
            mediatorState: false,
            //重签弹出框状态
            resignDialog: false,
            reSignArr: [],
            againDialog: false,
            againDocument: {},
            againArr: [],
            isIndeterminate:false,
            checkAll: false,
            confirmList: [],
            emailList: [],
            userSignImg: '',
            isRealName: '',
            //是否重签 1是 0否
            isReSignStatus: '0',
            isManage: false, // 管理员角色
            //当前需要签署的docId
            docId: '',
            wsLink: '',
            currentRoomId: '',
            noticeList: [] //公告签署列表
        }
    },
    watch: {
        '$route'() {
            if (this.$route.query.activeName == 'third') {
                this.getWorkerDocBookList()
            }
        }
    },
    filters: {
        dateFormat(time) {
            let date = new Date(time);
            return dateformat(date, 'yyyy-MM-dd hh:mm');
        }
    },
    created() {
        this.curRoomId = this.$route.query.meetingid
        this.getWorkerDocBookList()
    },
    mounted() {
        let loginInfouser = JSON.parse(getStore('loginInfo'));
        this.isManage = isManageRole(loginInfouser.userRoles)

        if (loginInfouser.hasOwnProperty('personType') && loginInfouser.personType == 'STAFF') {
            this.mediatorState = true
            this.getUsersSign()
        }

        let wsInfo = this.$store.getters.getWSLink
        if (wsInfo.hasOwnProperty('wsLink')) {
            this.wsLink = wsInfo.wsLink
            this.currentRoomId = wsInfo.currentRoomId
        } else {
            let currentRoomId = this.$route.query.roomid.indexOf(',') != -1 ? this.$route.query.roomid.split(',')[0] : this.$route.query.roomid
            this.$store.dispatch('initWSLink', {
                currentRoomId: currentRoomId
            }).then(res => {
                this.wsLink = res
                this.currentRoomId = currentRoomId
            })
        }

    },
    methods: {
        getCurUserInfo() {
            let userInfo = JSON.parse(getStore('loginInfo'))
            this.curUserInfo = {
                'curUserId': userInfo.memberId,
                'isRealName': userInfo.signName
            }
            this.isRealName = userInfo.signName
        },
        getWorkerDocBookList() {
            let curUserSign, needSign, needSignArray = []
            this.workerDocumentList = []
            let groupList = []
            onlineDocList({
                "objectId": this.curRoomId,
                "objectType": "MEDIATION"
            }).then(res => {
                if (res.data.code === 1000) {
                    let resData = res.data.data

                    res.data.data.forEach(item => {
                        let find = false
                        groupList.some(item2 => {
                            if (item.sign == item2.sign) {
                                item2.list.push(item)
                                find = true
                                return true
                            }
                        })
                        if (!find) {
                            groupList.push({
                                sign: item.sign,
                                docName: item.docName,
                                list: [item]
                            })
                        }
                    })

                    groupList.forEach((element, index) => {
                        this.workerDocumentList.push(element)
                    })
                } else {
                    this.$message.error(res.data.message)
                }
                console.log('文书', this.workerDocumentList)
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err
                })
            })
        },
        handleSendBook() {
            this.$refs.senddialog.openDocDialog()
        },
        handleCheckAllChanged(val) {
            this.againArr = []
            if (val) {
                this.emailList.forEach(item => {
                    this.againArr.push(item.userId)
                })
            }
            this.isIndeterminate = false;
        },
        handleAgainArrChanged(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.confirmList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.confirmList.length;
        },
        documentsUpdate(data) {
            this.getWorkerDocBookList()
            AlertEmit.$emit('sendBookWebSocket', data)
        },
        handleCloseSign(done) {
            done()
        },
        editEmail(item, cancel) {
            // 校验
            if (!cancel && item.editStatus) {
                if (!item.email || item.email == null || item.email == "" || item.email == undefined) {
                    this.$message.warning('请输入邮箱')
                    return;
                }
                if (!/^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/.test(item.email)) {
                    this.$message.warning('邮箱格式错误')
                    return
                }
                setUserEmail({
                    email: item.email,
                    meetingId: this.curRoomId,
                    userId: item.userId
                }).then(res => {
                    if (res.data.code === 1000) {
                        this.$message.success('修改成功')
                        item.editStatus = false
                        this.$forceUpdate()
                    }
                })
            } else {
                item.editStatus = !item.editStatus
                if (cancel) { // 取消编辑，需要恢复原邮箱
                    item.email = item.copyEmail
                }
                this.$forceUpdate()
            }
        },
        deletefile(doc) {
            let params = {documentId : doc.docId, attachId: doc.id}
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            delDocAndAttach(params).then(res => {
                loading.close()
                if (res.data.code === 1000) {
                    this.$message.success('已成功删除')
                    // 刷新列表
                    this.loadPage()
                } else {
                    this.$message('删除失败')
                }
                console.log(res)
            }).catch(err => {
                loading.close()
                this.$message('删除失败')
                console.log(err)
            })
            console.log(doc)
        },
        downfile(doc, type) {
            if (type) {
                filedownload('/gzzc/docBook/clerkRecordDownload', {
                    fileId: doc.attachFileId,
                    id: doc.attachId
                }, doc.attachFileName)
            } else {
                filedownload('/gzzc/docBook/clerkRecordDownload', {
                    fileId: doc.fileId,
                    id: doc.id
                }, doc.fileName)
            }
        },
        preview(doc, type) {
            if (type) {
                window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.attachFileId)
            } else {
                window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.fileId)
            }
        },
        sendAgain(doc) {
            this.againDialog = true
            this.againDocument = doc
        },
        previewG(doc){
             window.open(config.baseURL + '/gzzc/docBook/previewImg/' + doc.content)
        },
        showReSignDialog() {
            this.resignDialog = true
        },
        //获取用户签名接口
        getUsersSign() {
            getUserSingnatureAndEmail({
                objectId: this.curRoomId
            }).then((res) => {
                console.log('res:', res)
                if (res.data.code == 1000) {
                    this.confirmList = res.data.data
                    this.emailList = deepClone(res.data.data)
                    this.emailList.forEach(item => {
                        item.editStatus = false
                        item.copyEmail = item.email
                    })
                }
            })
        },
        closeReSignDialog() {
            this.reSignArr = []
            this.resignDialog = false
        },
        closeAgainDialog() {
            this.againArr = []
            this.againDocument = {}
            this.checkAll = false
            this.isIndeterminate = false
            this.againDialog = false
        },
        sendDocAgain() {
            let param = {
                meetingId: this.curRoomId,
                documentId: this.againDocument.docId,
                documentType: this.againDocument.sign,
                userIdList: this.againArr,
                fileId: this.againDocument.fileId,
                fileName: this.againDocument.fileName
            }
            this.BtnLoading = true
            manualSendDeliveryDoc(param).then(res => {
                this.BtnLoading = false
                if (res.data.code == 1000) {
                    this.closeAgainDialog()
                    this.$message.success('发送至邮箱或手机成功')
                    this.loadPage()
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(error => {
                this.BtnLoading = false
            })
        },
        //发送重新签名
        reSignAgain() {
            let ul = []
            console.log(this.reSignArr)
            if (this.reSignArr.length == 0) {
                this.$message.warning('请选择需重新签名的当事人')
                return
            } else if (this.reSignArr.length == 1) {
                ul.push(this.confirmList.filter(n => n.userName == this.reSignArr)[0].userId)
            } else {
                this.reSignArr.map(item => {
                    ul.push(this.confirmList.filter(n => n.userName == item)[0].userId)
                })
            }
            userSignAgain({
                meetingId: this.curRoomId,
                userIdList: ul
            }).then((res) => {
                console.log('res:', res)
                if (res.data.code == 1000) {
                    this.$message.success('通知重签发送成功')
                    this.resignDialog = false
                    this.getUsersSign()
                    this.getWorkerDocBookList()
                } else {
                    this.$message.error('发送重签失败')
                }
            })
        },
        loadPage() {
            this.getWorkerDocBookList()
        },
    }
}
</script>

<style lang="scss">
.docSign_list {
    margin: 26px 40px 20px 65px;

    .docSign_content {
        .box-card {
            margin-bottom: 12px;
        }

        padding-bottom: 40px;

        .tit {
            font-size: 20px;
            color: #333333;
            position: relative;
            padding-left: 12px;
            margin-bottom: 30px;

            &:before {
                position: absolute;
                content: '';
                width: 4px;
                height: 20px;
                background-color: #1e6dcb;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .el-card__header {
            padding: 10px 20px;
            background-color: #f8f9fa;

            span {
                font-size: 14px;
            }
        }

        .doc_item {
            line-height: 32px;

            .doc_name {
                font-size: 14px;
            }

            .el-tag {
                margin-right: 8px;
            }
        }
    }

    .flex-center {
        display: flex;
        align-items: center;
    }

    .docSign_foot {
        text-align: center;

        .el-button {
            color: #fff;
        }
    }

    .docSign_foot_block {
        width: 100%;
        height: 80px;
        margin-top: 20px;
        font-size: 16px;
        border-top: 1px solid #EBEEF5;
        display: flex;
        align-items: center;

        .left {
            margin-left: 10px;
        }

        .resign {
            margin-left: 20px;
            text-decoration: underline;
            color: #1e6dcb;
            cursor: pointer;
        }

        .signImg {
            width: 120px;
            margin-left: 10px;
        }
    }
}
.email_block {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 24px 0;
    margin-bottom: 20px;
    line-height: 40px;
    font-size: 16px;
    border-top: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    align-items: center;

    .email_item {
        display: flex;
        margin-right: 40px;
        margin-bottom: 24px;
        align-items: center;
        div {
            flex-shrink: 0;
        }
        .el-button {
            margin-left: 15px;
            color: #1e6dcb;
            cursor: pointer;
        }
    }
}

.booksign_dialog {
    .booksign_content {
        text-align: center;
        font-size: 16px;

        i.sign-icon-warning {
            display: block;
            margin: 0 auto 20px;
            width: 56px;
            height: 56px;
            background: url("~@/assets/images/ico-sign_warning.png")
        }

        i.sign-icon-wrong {
            display: block;
            margin: 0 auto 20px;
            width: 56px;
            height: 56px;
            background: url("~@/assets/images/ico-sign_wrong.png")
        }
    }

    .dialog-footer {
        display: inline-block;
        padding-bottom: 20px;

        .el-button {
            min-width: 120px;
            height: 40px;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }
}
</style>
